
import { useMemo } from 'react';
import { debounce } from 'lodash';
import { Table,Input,Button,Empty,Space } from 'antd';
import { DataType, column } from './column';
import { collectionRecord } from '@/services/claims';
import dayjs from 'dayjs';
import useSearchTable from '@/hooks/useList';

export default function ClaimsPage() {
  const defaultValue = {
    Mobile: '',
    ActivityName: '',
    ProductName: ''
  }
  const {
    data,
    total,
    loading,
    fetchData,
    searchParams,
    handleSearch,
    handlePageChange
  } = useSearchTable(collectionRecord, defaultValue );

  return (
    <>
      <div className="headerTitle">
        <div>
          <h2>领取记录</h2>
        </div>
      </div>

      <div className="card">
        <div className="searchCond" style={{ width:'55%' }}>
          <Space size='middle'>
          <Input allowClear placeholder="手机号"  size='large' onChange={(e) => handleSearch({ Mobile: e.target.value })}/>
          <Input allowClear placeholder="权益包名称"   size='large' onChange={(e) => handleSearch({ ActivityName: e.target.value })}/>
          <Input allowClear placeholder="权益名称"  size='large' onChange={(e) => handleSearch({ ProductName: e.target.value })}/>
          
            <Button type="primary" size='large' onClick={()=>{ fetchData() }}>搜索</Button>
          
          {/* <Button type="primary" size='large' onClick={()=>{ 
            handleSearch({ ProductName: e.target.value })
           }}>重置</Button> */}
           </Space>
        </div>

        <div className="overflow-x-auto">
          <Table rowKey='id'
          columns={[
            ...column,
            {
              title: '领取时间',
              dataIndex: 'collectionTime',
              key: 'collectionTime',
              render(value, record, index) {
                return (
                  <p>{record.collectionTime && dayjs(record.collectionTime ).format("YYYY-MM-DD HH:mm:ss")}</p>
                );
              },
            }
          ]} 
          dataSource={data as DataType[]}
          loading={loading}
          pagination={{ current: searchParams.PageIndex, pageSize:searchParams.PageSize, total, onChange: handlePageChange,showSizeChanger:false  }}
          scroll={{ x: 'max-content', y: 580 }}
          locale={{ emptyText: <Empty description="暂无数据"></Empty> }}
          />
        </div>
      </div>
    </>
  );
} 